import { api } from 'shared/api'

import { recommendationsApiSchema } from './schemas'

export const recommendationsApi = {
  personalizedRecommendationsData: api.account.createGet({
    url: '/dashboard/personalizedRecommendationsData',
    schemas: recommendationsApiSchema.personalizedRecommendationsData,
    scope: 'automation_starters',
  }),
}
